import axios from 'axios';
import { API_CONFIG } from '../config/api';

const API_URL = API_CONFIG.BASE_URL;

export interface CompanySettings {
  id: string;
  companyName: string;
  logoUrl?: string;
  logoFilename?: string;
  createdAt: string;
  updatedAt: string;
}

// Create axios instance with auth header for protected routes
const createAuthenticatedAxios = () => {
  const token = localStorage.getItem('token');
  return axios.create({
    baseURL: API_URL,
    headers: {
      'Authorization': token ? `Bearer ${token}` : '',
    },
  });
};

// Create axios instance for public routes (no auth needed)
const createPublicAxios = () => {
  return axios.create({
    baseURL: API_URL,
  });
};

export const companyService = {
  // Get company settings (public route)
  async getCompanySettings(): Promise<CompanySettings> {
    const api = createPublicAxios();
    const response = await api.get<CompanySettings>('/company/settings');
    return response.data;
  },

  // Update company name (protected route)
  async updateCompanyName(companyName: string): Promise<CompanySettings> {
    const api = createAuthenticatedAxios();
    const response = await api.put<CompanySettings>('/company/settings', {
      companyName,
    });
    return response.data;
  },

  // Upload company logo (protected route)
  async uploadLogo(file: File): Promise<CompanySettings> {
    const api = createAuthenticatedAxios();
    const formData = new FormData();
    formData.append('logo', file);
    
    const response = await api.post<CompanySettings>('/company/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete company logo (protected route)
  async deleteLogo(): Promise<CompanySettings> {
    const api = createAuthenticatedAxios();
    const response = await api.delete<CompanySettings>('/company/logo');
    return response.data;
  },

  // Get logo URL for display
  getLogoUrl(filename: string): string {
    return `${API_URL}/company/logo/${filename}`;
  },
}; 